import $ from "jquery"
const vInputHandle = {
  bind(el, binding, vnode) {
      let max = binding.value.max
      let min = binding.value.min || 0
      let step = binding.value.step || 1
    let disabledClass = ""
    if(binding.value.noInputHandle){
      return
    }
    const templateAppend =
      '<div class="el-input-group__append"><div data-v-9ae29cf2="" class="icon-arrows-bg icon-portal-arrows-up"></div><div data-v-9ae29cf2="" class="' +
      disabledClass +
      ' icon-arrows-bg icon-portal-arrows-down"></div></div>'
    const templateSuffix = $(el).children(".el-input__suffix")[0]
    $(el)
      .find(".el-input__inner")
      .on("input propertychange", function (event) {
        if (!this.value || this.value == min) {
          $(el).children(".el-input-group__append").children(".icon-portal-arrows-down").addClass("el-input-disabled")
        } else if(this.value && this.value < min){
            // binding.value.this1[binding.value.type]=min
            // $(el).find(".el-input__inner").val(min)
            // $(el).children(".el-input-group__append").children(".icon-portal-arrows-down").addClass("el-input-disabled")
        } else if(this.value && this.value> max){
            // binding.value.this1[binding.value.type]=max
        } else{
          $(el)
            .children(".el-input-group__append")
            .children(".icon-portal-arrows-down.el-input-disabled")
            .removeClass("el-input-disabled")
        }
      })
    $(el).mouseenter(() => {
      if ($(this).find(".el-input-group__append").length === 0) {
        $(el).children(".el-input__suffix").remove()
        $(el).append(templateAppend)
        $(el).removeClass("el-input--suffix")
        $(el).addClass("el-input-group")
        if (!$(el).find(".el-input__inner").val() || $(el).find(".el-input__inner").val() == min) {
          $(el).children(".el-input-group__append").children(".icon-portal-arrows-down").addClass("el-input-disabled")
        }
        if (!$(el).find(".el-input__inner").val() || $(el).find(".el-input__inner").val() == max) {
          $(el).children(".el-input-group__append").children(".icon-portal-arrows-up").addClass("el-input-disabled")
        }
      }
      $(el)
        .children(".el-input-group__append")
        .children(".icon-portal-arrows-up")
        .mousedown(function () {
            if ($(this).hasClass("el-input-disabled")) {
                return
            }
          $(this).css("background", "var(--inputArrowMousedownBgColor)")
          $(this).siblings(".icon-portal-arrows-down").css("background", "var(--inputArrowBgColor)")
        })
      $(el)
        .children(".el-input-group__append")
        .children(".icon-portal-arrows-up")
        .mouseup(function () {
            if(typeof max !== "undefined" && binding.value.this1[binding.value.type] == max){
                console.log("已经是最大值了")
                return
            }
          $(this).css("background", "var(--inputArrowHoverBgColor)")
          // binding.value.this1[binding.value.type]++
          binding.value.this1[binding.value.type]+=step
          let timer = setTimeout(()=>{
            if(binding.value.this1[binding.value.type] == max){
              $(el).children(".el-input-group__append").children(".icon-portal-arrows-up").addClass("el-input-disabled")
            }else{
              $(el).children(".el-input-group__append").children(".icon-portal-arrows-up").removeClass("el-input-disabled")
            }
            timer = null
          },100)
          $(el).children(".el-input-group__append").children(".icon-portal-arrows-down.el-input-disabled").removeClass("el-input-disabled")
        })
      $(el)
        .children(".el-input-group__append")
        .children(".icon-portal-arrows-down")
        .mousedown(function () {
          if ($(this).hasClass("el-input-disabled")) {
            return
          }
          $(this).css("background", "var(--inputArrowMousedownBgColor)")
          $(this).siblings(".icon-portal-arrows-up").css("background", "var(--inputArrowBgColor)")
        })
      $(el)
        .children(".el-input-group__append")
        .children(".icon-portal-arrows-down")
        .mouseup(function () {
          if (binding.value.this1[binding.value.type] > min) {
            $(this).css("background", "var(--inputArrowHoverBgColor)")
            // binding.value.this1[binding.value.type]--
            binding.value.this1[binding.value.type]-=(binding.value.reduceStep ? binding.value.reduceStep: step)
          }
          $(el).children(".el-input-group__append").children(".icon-portal-arrows-up").removeClass("el-input-disabled")
          if (binding.value.this1[binding.value.type] == min) {
            $(el).children(".el-input-group__append").children(".icon-portal-arrows-down").addClass("el-input-disabled")
          }else{
            $(el).children(".el-input-group__append").children(".icon-portal-arrows-down").removeClass("el-input-disabled")
          }
        })
      $(el)
        .find(".icon-arrows-bg")
        .mouseleave(function () {
          $(this).css("background", "var(--inputArrowBgColor)")
        })
      $(el)
        .find(".icon-arrows-bg")
        .mouseenter(function () {
          if ($(this).hasClass("el-input-disabled")) {
            return
          }
          $(this).css("background", "var(--inputArrowHoverBgColor)")
        })
    })
    $(el).mouseleave(() => {
      $(el).children(".el-input-group__append").remove()
      $(el).removeClass("el-input-group")
      $(templateSuffix).css("position", "absolute")
      $(templateSuffix).css("right", "8px")
      $(el).append(templateSuffix)
    })
  }
}
export default vInputHandle
